angular.module('unergie.main')
.directive('userInfoContractAdjustment', (TableGeneratorService, BoFeaturesService, DataAccess, MetaWatcher, AlertManager, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractAdjustment.html',
        link($scope) {
            const canForceAdjustment = BoFeaturesService.get('canForceAdjustment')

            $scope.adjustments = {
                columns: {
                    amount: { label: 'Montant', mode: 'search_operator' },
                    value_date: { label: 'Date de valeur', mode: 'search_date' },
                    comments: { label: 'Commentaires', mode: 'search_wildcard' },
                },
            }

            $scope.refresh = () => TableGeneratorService.getTable($scope.adjustments, 'manual-adjustments', '', null, { search: { id_contract: $scope.contract.id } })


            // CREATE NEW
            $scope.adjustFields = {
                label: { label: 'Un montant positif rajoute du solde négatif et inversement', type: 'label' },
                amount: { label: 'Montant', required: true, type: 'number' },
                value_date: { label: 'Date de valeur', required: true, type: 'date' },
                comments: { label: 'Commentaires', required: true, type: 'text' },
            }

            if (canForceAdjustment) {
                $scope.adjustFields.force = { label: 'Forcer (ajustement supérieur au solde)', type: 'checkbox' }
            }

            $scope.adjustPayload = {
                amount: 0,
                value_date: moment().toDate(),
                comments: undefined,
                force: false,
            }

            $scope.prepareAdjustPayload = () => {
                $scope.adjustPayload.amount = Number($scope.contract.contractBalance.balance)
            }


            $scope.createManualAdjustment = function () {
                const payload = angular.copy($scope.adjustPayload)
                payload.value_date = moment($scope.adjustPayload.value_date).format('YYYY-MM-DD')
                $scope.creatingAdj = true
                return DataAccess.createAdjustment({ id_contract: $scope.contract.id }, payload).$promise.then(() => {
                    AlertManager.success('Ajustement créé')
                    MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
                    $scope.refresh()
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.creatingAdj = false
                })
            }

            // DELETE
            $scope.deleteAdjustment = function (adj) {
                adj.deleting = true
                return DataAccess.deleteAdjustment({ id: adj.id }).$promise.then(() => {
                    AlertManager.success('Ajustement supprimé')
                    $scope.refresh()
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    adj.deleting = false
                })
            }

            const activate = () => $scope.refresh()

            return activate()
        },
    })
)
